import { EntityDefinition } from '@/types/crud';

export const abacResourceEntity: EntityDefinition = {
  name: 'abacResource',
  displayName: 'Resources',
  apiEndpoint: '/abac/resources',
  idField: 'id',
  nameField: 'name',
  copyable: false,
  deletable: false,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'abac.fieldLabels.id',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'name',
      label: 'abac.fieldLabels.name',
      type: 'text',
      required: true,
      order: 1
    },
    {
      key: 'resource_type',
      label: 'abac.fieldLabels.resourceType',
      type: 'text',
      order: 2
    },
    {
      key: 'description',
      label: 'abac.fieldLabels.description',
      type: 'text',
      order: 3
    },
    {
      key: 'status',
      label: 'abac.fieldLabels.status',
      type: 'text',
      order: 4
    },
    {
      key: 'custom_attributes',
      label: 'abac.fieldLabels.customAttributes',
      type: 'custom',
      readOnly: true,
      formHidden: true,
      order: 5,
      render: (value: any[]) => {
        if (!value || value.length === 0) {
          return 'No attributes assigned';
        }
        
        const formatValue = (val: any, dataType?: string) => {
          if (val === null || val === undefined) return 'N/A';
          
          // If data type is provided, use it for formatting
          if (dataType) {
            switch (dataType) {
              case 'JSON':
                try {
                  return typeof val === 'string' ? val : JSON.stringify(val, null, 2);
                } catch {
                  return String(val);
                }
              case 'BOOLEAN':
                return val ? 'Yes' : 'No';
              case 'DATE':
                return new Date(val).toLocaleDateString();
              case 'NUMBER':
                return Number(val).toString();
              case 'STRING':
              default:
                return String(val);
            }
          }
          
          // Fallback: try to detect type and format accordingly
          if (typeof val === 'object') {
            try {
              return JSON.stringify(val, null, 2);
            } catch {
              return String(val);
            }
          }
          
          return String(val);
        };
        
        return value.map((attr: any) => 
          `${attr.attribute_name}: ${Array.isArray(attr.value) 
            ? attr.value.map((v: any) => formatValue(v, attr.data_type)).join(', ')
            : formatValue(attr.value, attr.data_type)
          }`
        ).join('<br>');
      }
    },
    {
      key: 'created_at',
      label: 'abac.fieldLabels.createdAt',
      type: 'datetime',
      order: 6
    }
  ]
};
